import { render, staticRenderFns } from "./adminOrders.vue?vue&type=template&id=481cb5aa&scoped=true"
import script from "./adminOrders.vue?vue&type=script&lang=js"
export * from "./adminOrders.vue?vue&type=script&lang=js"
import style0 from "./adminOrders.vue?vue&type=style&index=0&id=481cb5aa&prod&lang=scss&scoped=true"
import style1 from "./adminOrders.vue?vue&type=style&index=1&id=481cb5aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481cb5aa",
  null
  
)

export default component.exports